import type { ReactNode } from 'react';
import { fmtInt } from '../../lib/format';

/** Compact metric: value + label ('…' while loading). Place inside a `StatStrip`. */
export function Stat({ label, value }: { label: string; value: number | undefined }) {
  return (
    <div className="bo-metric">
      <span>
        <strong>{value === undefined ? '…' : fmtInt(value)}</strong>
        <small>{label}</small>
      </span>
    </div>
  );
}

/** Row of compact metrics on the data gradient; trailing `children` (chips, actions) share the row. */
export function StatStrip({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={className ? `bo-metrics bo-metrics--compact ${className}` : 'bo-metrics bo-metrics--compact'}>
      {children}
    </div>
  );
}
